const TEN_DIGIT_WEIGHTS = [2, 4, 10, 3, 5, 9, 4, 6, 8] as const
const TWELVE_DIGIT_FIRST_WEIGHTS = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8] as const
const TWELVE_DIGIT_SECOND_WEIGHTS = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8] as const

function checksum(digits: readonly number[], weights: readonly number[]): number {
  const sum = weights.reduce((result, weight, index) => result + (digits[index] ?? 0) * weight, 0)
  return (sum % 11) % 10
}

export function isValidInn(value: string): boolean {
  if (!/^(?:\d{10}|\d{12})$/.test(value)) return false
  const digits = [...value].map(Number)

  if (digits.length === 10) {
    return checksum(digits, TEN_DIGIT_WEIGHTS) === digits[9]
  }

  return checksum(digits, TWELVE_DIGIT_FIRST_WEIGHTS) === digits[10]
    && checksum(digits, TWELVE_DIGIT_SECOND_WEIGHTS) === digits[11]
}

export const INN_VALIDATION_MESSAGE = 'Введите корректный ИНН: 10 или 12 цифр с верной контрольной суммой.'
